import { createFileRoute } from '@tanstack/react-router'
import { AppUserHelmetList } from '@/features/app-user-helmets/pages/app-user-helmet-list'

export const Route = createFileRoute('/_authenticated/app-user-helmets/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <AppUserHelmetList />
}
